import { Component, EventEmitter, Output } from '@angular/core';
import { UserEditDialog } from '@app/shared/edit-dialog/user/user-edit-dialog.component';
import { addSelectFilterConfig, ModalFilter } from '@app/shared/model-table/model-table-filter';
import { WebClient } from '@injectables';
import { op } from '@lib/rxjs';
import { Client, Site, User } from '@models';

@Component({
    selector: 'users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.scss'],
})
export class UsersComponent {
    constructor(private readonly webClient: WebClient) { }

    public SearchText: string = '';
    public selected: string = 'firstName';
    public readonly model = User;
    public readonly restClient = this.webClient.model.user;
    public readonly editDialog = UserEditDialog;
    public readonly deletable = (v: User) => v.email !== 'admin@strayos.com';

    public readonly clients$ = this.webClient.model.client.search$({}).pipe(
        op.map((values) => new Map(values.map((v) => [v.id, v]))),
        op.startWith(new Map<number, Client>())
    );

    public readonly sites$ = this.webClient.model.site.search$({}).pipe(
        op.map((values) => new Map(values.map((v) => [v.id, v]))),
        op.startWith(new Map<number, Site>())
    );

    private ngOnInit() {
        this.clients$.subscribe((client) => {
            const clientOptions = Array.from(client.entries()).map(([id, value]) => ({
                value: id,
                label: value.name
            }));

            if(clientOptions?.length){
                this.filterConfigs.push(addSelectFilterConfig('Client','clientId',true,clientOptions));
            }

        });
        this.sites$.subscribe((site) => {
            const siteOptions = Array.from(site.entries()).map(([id, value]) => ({
                value: id,
                label: value.name
            }));

            if(siteOptions?.length){
                this.filterConfigs.push(addSelectFilterConfig('Site','siteId',true,siteOptions));
            }
        });
    }

    public filterConfigs: ModalFilter[] = [
        {
            type: 'input-string',
            column: 'Email',
            dbColumn: 'email',
        },
        {
            type: 'input-string',
            column: 'First Name',
            dbColumn: 'firstName',
        },
        {
            type: 'input-string',
            column: 'Last Name',
            dbColumn: 'lastName',
        },
        {
            type: 'select-string',
            column: 'Permissions',
            dbColumn: 'permissions',
            isValueLabelPair: true,
            options: [{ value: 0, label: "Standard", }, { value: 1, label: "Site Admin", }, { value: 2, label: "Client Admin", }, { value: 3, label: "Multi Client Admin" }, { value: 4, label: "Super Admin" }]
        }]
}
